<aside class="sidebar">
  <div class="logo">
    <svg width="40" height="40" viewBox="0 0 47 49" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M35.1177 23.3562V14.7278C35.1177 13.4023 33.6752 12.575 32.5153 13.2334L13.6523 23.9832C12.9772 24.3668 12.5618 25.0796 12.5618 25.8497V34.4524C12.5618 35.775 14.0043 36.6052 15.1613 35.9468L34.0214 25.2228C34.7023 24.8392 35.1177 24.1263 35.1177 23.3562Z" fill="#1AB2AE"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.5 47.2748V38.6664C23.5 37.8991 23.9126 37.1863 24.5819 36.8027L39.1749 28.4176C39.8443 28.0311 40.2569 27.3212 40.2569 26.5539V10.7485C40.2569 9.76369 41.3244 9.1396 42.1928 9.61768L44.9365 11.1292C45.6261 11.51 46.0531 12.2285 46.0531 13.013V36.1758C46.0531 36.9487 45.6376 37.6615 44.9625 38.0452L26.1024 48.7691C24.9426 49.4276 23.5 48.6002 23.5 47.2748Z" fill="#1AB2AE"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M23.4999 1.72499V10.3334C23.4999 11.1006 23.0873 11.8134 22.4179 12.1971L7.82493 20.5821C7.15558 20.9686 6.74301 21.6786 6.74301 22.4458V38.2513C6.74301 39.2361 5.67551 39.8601 4.80709 39.3821L2.06332 37.8705C1.37378 37.4898 0.946777 36.7712 0.946777 35.9868V12.824C0.946777 12.051 1.36224 11.3382 2.03736 10.9546L20.8975 0.230612C22.0573 -0.427829 23.4999 0.402379 23.4999 1.72499Z" fill="#1AB2AE"/>
    </svg>
  </div>

  <nav class="menu">
    <ul>
      @for (item of menuItems; track item) {
        <li class="menu-item" [class.active]="selectedItem === item.label"
          [class.disabled]="!item.enabled" [attr.aria-disabled]="!item.enabled"
          (click)="selectItem(item)">
          <mat-icon class="icon backoffice-icon backoffice-icon-medium">{{ item.icon }}</mat-icon>
          <span>{{ item.label }}</span>
        </li>
      }
    </ul>
  </nav>

    <div
        class="footer"
        (mouseenter)="showUserDetails()"
        (mouseleave)="hideUserDetails()"
        (focusin)="showUserDetails()"
        (focusout)="onUserFocusOut($event)"
    >
        <div
            class="user-profile-trigger"
            role="button"
            tabindex="0"
            aria-label="Exibir dados principais do usuário logado"
            [attr.aria-expanded]="userDetailsVisible"
        >
            <div class="user-icon">
                <span>{{ userInitials() }}</span>
            </div>
            <span class="username">{{ userFirstName() }}</span>
        </div>

        @if (userDetailsVisible && userDetails().length) {
            <mat-card class="user-details-card" role="dialog" aria-label="Dados principais do usuário logado">
                <mat-card-header>
                    <mat-card-title>Meu perfil</mat-card-title>
                    <mat-card-subtitle>Dados do Microsoft Entra ID</mat-card-subtitle>
                </mat-card-header>
                <mat-card-content>
                    <dl class="user-details-list">
                        @for (detail of userDetails(); track detail.label) {
                            <div class="user-detail-row">
                                <dt>{{ detail.label }}</dt>
                                <dd>{{ detail.value }}</dd>
                            </div>
                        }
                    </dl>
                </mat-card-content>
            </mat-card>
        }
    </div>

    <button
        mat-icon-button
        class="logout-btn"
        matTooltip="Sair do sistema"
        matTooltipPosition="right"
        (click)="authViewModel.logout()">
        <mat-icon>logout</mat-icon>
    </button>
</aside>
